<template>
<div class="container-fluid">
    <div class="row">
        <!-- <header-vpos></header-vpos> -->
        <header class="p-0">
            <label for="toggle-1" class="toggle-menu" @click="toggleMenu">
                <ul>
                    <li></li>
                    <li></li>
                    <li></li>
                </ul>
            </label>
            <!-- <strong @click="toggleMenu"> &#9776;	</strong> -->
            <nav class="nav_center" style="padding: 0" :style="{ display: isMenuVisible ? 'block' : 'none' }">
                <ul style="list-style: none">
                    <li :class="{ topmenuactive: activeTab === 'vcard' }" @click="changeTab('vcard')">
                        <a id="urlVcard" href="taichinhtoandien#vcard/">{{
                currentLanguage.header_text_viDienTu
              }}</a>
                    </li>
                    <li :class="{ topmenuactive: activeTab === 'giaodichthongminh' }" @click="changeTab('giaodichthongminh')">
                        <a id="urlGiaodichthongminh" href="taichinhtoandien#giaodichthongminh">
                            {{ currentLanguage.header_text_giaodichthongminh }}
                        </a>
                    </li>
                    <li :class="{ topmenuactive: activeTab === 'taichinhtoandien' }" @click="changeTab('taichinhtoandien')">
                        <a id="urlTaichinhtoandien" href="taichinhtoandien#taichinhtoandien">
                            {{ currentLanguage.header_text_qrThanhToan }}
                        </a>
                    </li>
                    <!-- <li :class="{ topmenuactive: activeTab === 'giaothongthongminh' }" @click="changeTab('giaothongthongminh')" style="display: none;">
              <a id="urlGiaoThong" href="taichinhtoandien#giaothongthongminh">
                {{ currentLanguage.header_text_giaothongthongminh }}
              </a>
            </li>
            <li :class="{ topmenuactive: activeTab === 'dichvucongthongminh' }"
              @click="changeTab('dichvucongthongminh')">
              <a id="urlDVC" href="taichinhtoandien#dichvucongthongminh" style="display: none;">
                {{ currentLanguage.header_text_dichVuCongThongMinh }}
              </a>
            </li> -->
                   
                    <li :class="{ topmenuactive: activeTab === 'ytethongminh' }" @click="changeTab('ytethongminh')" style="display: none;">
                        <a id="urlYte" href="taichinhtoandien#ytethongminh">
                            {{ currentLanguage.header_text_yteThongMinh }}
                        </a>
                    </li>
                    <li :class="{ topmenuactive: activeTab === 'AIeditor' }" @click="changeTab('AIeditor')">
                        <a id="urlBai1" href="taichinhtoandien#AIeditor/">{{
                currentLanguage.header_text_TrinhbientapAi
              }}</a>
                    </li>

                    <li :class="{ topmenuactive: activeTab === 'diemthanhtoan' }" @click="changeTab('diemthanhtoan')">
                        <a id="urlPos" href="taichinhtoandien#diemthanhtoan">{{
                currentLanguage.footer_text_diemThanhToan }}</a>
                    </li>
                    <li :class="{ topmenuactive: activeTab === 'DiemDinhDanh' }" @click="changeTab('DiemDinhDanh')">
                        <a id="urlBai2" href="taichinhtoandien#diemdinhdanh/">{{
                currentLanguage.footer_text_diemRaVao
              }}</a>
                    </li>

                    <li :class="{ topmenuactive: activeTab === 'gioiThieu' }" @click="changeTab('gioiThieu')">
                        <a id="urlGioithieu" href="taichinhtoandien#thuchiho/">{{
                currentLanguage.header_text_thuChiHoQuaAPI
              }}</a>
                    </li>
                    <li :class="{ topmenuactive: activeTab === 'DiemThanhToan' }" @click="changeTab('DiemThanhToan')">
                        <a id="DiemThanhToan" href="taichinhtoandien#hopdong/">{{
                currentLanguage.body_HopDong_text_title
              }} API</a>
              
                    </li>
                     <li :class="{ topmenuactive: activeTab === 'giaothongthongminh' }" @click="changeTab('giaothongthongminh')">
                        <a id="urlGiaoThong" href="taichinhtoandien#phocapthsinhtrachoc">
                            {{ currentLanguage.header_text_phoCapThe }}</a>
                    </li>
                    <li :class="{ topmenuactive: activeTab === 'dichvucongthongminh' }" @click="changeTab('dichvucongthongminh')">
                        <a id="urlDVC" href="taichinhtoandien#thesinhtrachoc">
                            {{ currentLanguage.header_text_theChip  }}</a>
                    </li>
                    <li :class="{ topmenuactive: activeTab === 'LienHe' }" @click="changeTab('LienHe')">
                        <a id="urlBai6" href="taichinhtoandien#LienHe/">{{
                currentLanguage.header_text_lienHe
              }}</a>
                    </li>

                </ul>
            </nav>
            <div class="menu_right" style="display: flex">
                <a @click="changeLanguage('vi')" class="lang" style="padding: 5px"><img src="img/img-item-vimass-2022/co/vi-VN.gif" />
                </a>
                <a @click="changeLanguage('en')" class="lang" style="padding: 5px"><img style="width: 25px" src="img/img-item-vimass-2022/co/us.png" />
                </a>
                <a @click="changeLanguage('cn')" class="lang d-none" style="padding: 5px"><img style="width: 25px" src="img/img-item-vimass-2022/co/cn.jpg" />
                </a>
                <a @click="changeLanguage('kr')" class="lang d-none" style="padding: 5px"><img style="width: 25px" src="img/img-item-vimass-2022/co/kr.jpg" />
                </a>
                <a @click="changeLanguage('ja')" class="lang d-none" style="padding: 5px">
                    <img style="width: 25px" src="img/img-item-vimass-2022/co/ja.jpg" />
                </a>

                <!-- <a onclick="changeLang('hi')" class="lang"
            ><img style="width: 25px" src="img/img-item-vimass-2022/co/hi.png" />
          </a> -->
                <span class="clickShow" style="color: #ffffff; cursor: pointer; margin: auto; padding: 5px"><i class="fa fa-ellipsis-h" aria-hidden="true"></i></span>
                <div class="showCo" style="display: none; margin: auto">
                    <a onclick="changeLang('us')" class="lang"><img src="img/img-item-vimass-2022/co/indo.jpg" />
                    </a>
                    <a onclick="changeLang('us')" class="lang"><img src="img/img-item-vimass-2022/co/tl.png" />
                    </a>
                    <a onclick="changeLang('us')" class="lang"><img src="img/img-item-vimass-2022/co/thailan.png" />
                    </a>
                    <a onclick="changeLang('us')" class="lang"><img src="img/img-item-vimass-2022/co/hu.jpg" />
                    </a>
                </div>
                <a id="urlHome" href="/" style="margin: 0 10px"><img style="width: 35px; height: 35px" src="img/home-icon-white-8.jpg" />
                </a>
            </div>
        </header>
        <div class="col-12 col-md-12">
            <div class="container-fluid p-2">
                <div class="row">
                    <!-- <SearchStore v-if="phoneSearch"></SearchStore> -->
                    <div id="giaodichthongminh" v-show="showGiaoDichthongminh" style="min-height: 500px" class="padding-top15">
                        <div class="title-bai-viet" v-html="titleGiaodichthongminh"></div>
                        <div v-html="contentGiaodichthongminh" style="text-align: start"></div>
                    </div>
                    <div id="gioiThieu" v-show="showGioiThieu" style="min-height: 500px" class="padding-top15">
                        <div class="title-bai-viet" v-html="titleGioiThieu"></div>
                        <div v-html="contentGioiThieu" style="text-align: start"></div>
                    </div>
                    <div id="giaothongthongminh" v-show="showGiaoThong" style="min-height: 500px" class="padding-top15">
                        <div class="title-bai-viet" v-html="titleGiaoThong"></div>
                        <div v-html="contentGiaoThong" style="text-align: start"></div>
                    </div>
                    <div id="dichvucong" v-show="showDichVuCong" style="min-height: 500px" class="padding-top15">
                        <div class="title-bai-viet" v-html="titleDichVuCong"></div>
                        <div v-html="contentDichVuCong" style="text-align: start"></div>
                    </div>
                    <div id="yte" v-show="showYte" style="min-height: 500px" class="padding-top15">
                        <div class="title-bai-viet" v-html="titleYte"></div>
                        <div v-html="contentYte" style="text-align: start"></div>
                    </div>
                    <div id="DiemThanhToan" v-show="showDiemThanhToan" style="min-height: 500px; background-image: none !important" class="padding-top15">
                        <div class="title-bai-viet" v-html="titleDiemThanhToan" style="text-align: start"></div>
                        <div v-html="contentDiemThanhToan" style="text-align: start"></div>
                    </div>
                    <!-- DiemDinhDanh -->

                    <div id="vcard" v-show="showVcard" style="min-height: 500px; background-image: none !important" class="padding-top15">
                        <div class="title-bai-viet" v-html="titleVCard"></div>
                        <div v-html="contentVCard"></div>
                        <!-- <img-app-vcard></img-app-vcard> -->
                    </div>
                    <div id="DiemDinhDanh" v-show="showDiemDinhDanh" style="min-height: 500px; background-image: none !important" class="padding-top15">
                        <div class="title-bai-viet" v-html="titleDiemDinhDanh"></div>
                        <div v-html="contentDiemDinhDanh"></div>
                    </div>
                    <div id="taichinhtoandien" v-show="showTaichinhtoandien" style="min-height: 500px; background-image: none !important">
                        <div class="title-bai-viet" v-html="titleTaichinhtoandien"></div>
                        <div v-html="contentTaichinhtoandien" style="text-align: start"></div>
                    </div>

                    <div id="diemthanhtoan" v-show="showPos" style="min-height: 500px; background-image: none !important">
                        <div class="title-bai-viet" v-html="titlePos"></div>
                        <div v-html="contentPos" style="text-align: start"></div>
                        <!-- Đang cập nhật... -->
                    </div>
                    <div id="aIeditor" v-show="showAIeditor" style="min-height: 500px; background-image: none !important">
                        <div class="title-bai-viet" v-html="titleAIeditor"></div>
                        <div v-html="contentAIeditor" style="text-align: start"></div>
                        <!-- <div class="container-fluid">
                <div class="row">
                  <div class="col-12 col-md-6">
                    <div class="card dark" style="margin: 1em auto; max-width: 60em" v-for="(itemLinhVuc, index) in items.slice(
                      0,
                      Math.ceil(items.length / 2)
                    )" :key="index">
                      <a :href="itemLinhVuc.url !== '#' ? itemLinhVuc.url : null" target="__blank">
                        <div class="d-flex">
                          <img style="width: 15%" :src="itemLinhVuc.imgLinhVuc" class="card-img-top" />

                          <div class="card-body">
                            <div class="text-section m-auto d-flex flex-column">
                              <h5 class="card-title" style="color: black">
                                {{ itemLinhVuc.title }}
                              </h5>
                              <p class="card-text" style="color: black; line-height: 1.3">
                                {{ itemLinhVuc.moTa }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>

                  <div class="col-12 col-md-6">
                    <div class="card dark" style="margin: 1em auto; max-width: 60em" v-for="(itemLinhVuc, index) in items.slice(
                      Math.ceil(items.length / 2)
                    )" :key="index">
                      <a :href="itemLinhVuc.url !== '#' ? itemLinhVuc.url : null" target="__blank">
                        <div class="d-flex">
                          <img style="width: 15%" :src="itemLinhVuc.imgLinhVuc" class="card-img-top" />

                          <div class="card-body">
                            <div class="text-section m-auto d-flex flex-column">
                              <h5 class="card-title" style="color: black">
                                {{ itemLinhVuc.title }}
                              </h5>
                              <p class="card-text" style="color: black; line-height: 1.3">
                                {{ itemLinhVuc.moTa }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div> -->
                    </div>
                    <div id="lienhe" v-show="showLienHe" style="min-height: 500px; background-image: none !important">
                        <div class="title-bai-viet" v-html="titleLienHe"></div>
                        <div v-html="contentLienHe" style="text-align: start"></div>
                    </div>
                    <ul class="mt-3" v-if="riengChecked">
                        <li v-for="store in listCuaHang" :key="store.id" class="p-2">
                            <div class="w-100 p-3" style="
                    height: 45px;
                    background-color: rgb(239 239 239);
                    border-radius: 10px;
                    border-bottom: 2px rgb(185 185 185) solid;
                    text-align: start;
                    cursor: pointer;
                  ">
                                <span style="font-weight: 600; margin-left: 20px">{{ store.storeName }}
                                </span>
                                | <span> {{ store.storeAdd }}</span>
                            </div>
                        </li>
                    </ul>
                    <div class="m-auto" v-if="chungChecked"></div>
                    <CreateStore class="d-none"></CreateStore>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-3 p-0 d-none" style="background-color: #f8f8f8">
            <VposLoginVue v-if="!Login"></VposLoginVue>
            <MainMenuVposVue v-if="menuThongTin"></MainMenuVposVue>
            <VposRegister v-if="register"></VposRegister>
        </div>
    </div>
</div>
<FooterView></FooterView>
</template>

<script>
import {
    imageUrls
} from "@/components/js/urlImg";
import VposLoginVue from "../Accounts/VposLogin.vue";
import MainMenuVposVue from "./MainMenuVpos.vue";
import VposRegister from "../Accounts/VposRegister.vue";

import CreateStore from "../DashHome/CreateStore.vue";
import {
    languages
} from "@/components/languages";
import {
    postLayTiGia
} from "@/components/js/VposServiceDanh";
import axios from "axios";
import {
    apiChiTietBaiViet
} from "@/components/listService";
import FooterView from "@/views/Vimass/Footer/FooterView.vue";

export default {
    components: {
        MainMenuVposVue,
        VposLoginVue,
        VposRegister,
        CreateStore,
        FooterView,
    },
    data() {
        return {
            activeTab: "vcard",
            isMenuVisible: false,
            imageUrls: imageUrls,
            currentLanguage: languages.vi,
            Login: false,
            menuThongTin: false,
            register: false,
            user: "",
            listCuaHang: [],
            bannerQuangCao: true,
            phoneSearch: true,
            slideWeb: true,

            showTaichinhtoandien: true,
            isActiveTaichinhtoandien: true,

            showGiaoThong: false,
            isActiveGiaoThong: false,

            showDichVuCong: false,
            isActiveDichVuCong: false,

            showYte: false,
            isActiveYte: false,

            showAIeditor: false,
            isActiveAIeditor: false,

            showLienHe: false,
            isActiveLienHe: false,

            showPos: false,
            isActivePos: false,

            showVcard: false,
            isActiveVcard: false,

            showGiaoDichthongminh: false,
            isActiveGiaoDichthongminh: false,

            titleVCard: "",
            contentVCard: "",

            titleGiaodichthongminh: "",
            contentGiaodichthongminh: "",

            titlePos: "",
            contentPos: "",
            titleTaichinhtoandien: "",
            contentTaichinhtoandien: "",
            titleLienHe: "",
            contentLienHe: "",
            titleAIeditor: "",
            contentAIeditor: "",

            titleGiaoThong: "",
            contentGiaoThong: "",

            titleDichVuCong: "",
            contentDichVuCong: "",

            titleYte: "",
            contentYte: "",

            //show
            showGioiThieu: false,
            showDiemThanhToan: false,
            showDiemDinhDanh: false,

            //active tab
            isActiveGioiThieu: true,
            isActiveDiemThanhToan: false,
            isActiveDiemDinhDanh: false,

            //title
            titleGioiThieu: "",
            titleDiemThanhToan: "",
            titleDiemDinhDanh: "",

            //content
            contentGioiThieu: "",
            contentDiemThanhToan: "",
            contentDiemDinhDanh: "",

            docId: "1TGA7zcPFDEqr0JcSZUxadu7EMPuFwgJo", // ID của tài liệu Google Docs
            embeddedUrl: "",

            items: [],
        };
    },
    created() {
        const savedLanguage = localStorage.getItem("languages") || "vi";
        if (savedLanguage && languages[savedLanguage]) {
            this.currentLanguage = languages[savedLanguage];
        }
    },
    mounted() {
        this.fetchData();
        if (window.innerWidth <= 768) {
            this.isMenuVisible = false;
        } else {
            this.isMenuVisible = true;
        }
        if (!this.hasMounted) {
            this.hasMounted = true; // Set the flag to true to indicate that mounted has been executed
            this.lang = localStorage.getItem("languages") || "vi";
            if (this.lang == "vi") {
                document.title = "Vimass.vn - Vimass AI Editor";
            } else if (this.lang == "en") {
                document.title = "Vimass.vn - Vimass AI Editor";
            } else if (this.lang == "cn") {
                document.title = "Vimass.vn - Vimass AI Editor";
            } else if (this.lang == "kr") {
                document.title = "Vimass.vn - Vimass AI Editor";
            }
            this.checkUrl();

            this.performPostRequest("1749203550578RBETn", "vcard", this.lang);
            document.getElementById("urlHome").setAttribute("href", this.lang);
            document
                .getElementById("urlPos")
                .setAttribute("href", this.lang + "/taichinhtoandien#diemthanhtoan/");
            document
                .getElementById("urlTaichinhtoandien")
                .setAttribute("href", this.lang + "/taichinhtoandien#taichinhtoandien/");
            document
                .getElementById("urlBai1")
                .setAttribute("href", this.lang + "/taichinhtoandien#aieditor/");
            document
                .getElementById("urlBai6")
                .setAttribute("href", this.lang + "/taichinhtoandien#lienhe/");
            document
                .getElementById("urlVcard")
                .setAttribute("href", this.lang + "/taichinhtoandien#vwallet/");
            document
                .getElementById("urlGioithieu")
                .setAttribute("href", this.lang + "/taichinhtoandien#thuchiho/");
            document
                .getElementById("DiemThanhToan")
                .setAttribute("href", this.lang + "/taichinhtoandien#hopdong/");
            document
                .getElementById("urlBai2")
                .setAttribute("href", this.lang + "/taichinhtoandien#diemdinhdanh/");

            document
                .getElementById("urlGiaoThong")
                .setAttribute("href", this.lang + "/taichinhtoandien#phocapthsinhtrachoc/");
            document
                .getElementById("urlDVC")
                .setAttribute("href", this.lang + "/taichinhtoandien#thesinhtrachoc/");
            document
                .getElementById("urlYte")
                .setAttribute("href", this.lang + "/taichinhtoandien#ytethongminh/");
            document
                .getElementById("urlGiaodichthongminh")
                .setAttribute("href", this.lang + "/taichinhtoandien#giaodichthongminh/");

            const hash = window.location.hash;
            if (hash && hash.includes("#diemthanhtoan")) {
                this.changeTab("diemthanhtoan");
            } else if (hash && hash.includes("#taichinhtoandien")) {
                this.changeTab("taichinhtoandien");
            } else if (hash && hash.includes("#aieditor")) {
                this.changeTab("AIeditor");
            } else if (hash && hash.includes("#lienhe")) {
                this.changeTab("LienHe");
            } else if (hash && hash.includes("#thuchiho")) {
                this.changeTab("gioiThieu");
            } else if (hash && hash.includes("#hopdong")) {
                this.changeTab("DiemThanhToan");
            } else if (hash && hash.includes("#vwallet")) {
                this.changeTab("vcard");
            } else if (hash && hash.includes("#diemdinhdanh")) {
                this.changeTab("DiemDinhDanh");
            } else if (hash && hash.includes("#phocapthsinhtrachoc")) {
                this.changeTab("giaothongthongminh");
            } else if (hash && hash.includes("#thesinhtrachoc")) {
                this.changeTab("dichvucongthongminh");
            } else if (hash && hash.includes("#ytethongminh")) {
                this.changeTab("ytethongminh");
            } else if (hash && hash.includes("#giaodichthongminh")) {
                this.changeTab("giaodichthongminh");
            } else {
                this.changeTab("vcard");
            }

        }
        if (window.innerWidth <= 768) {
            this.isMenuVisible = false;
        } else {
            this.isMenuVisible = true;
        }
    },
    beforeUnmount() {
        window.removeEventListener("resize", this.checkScreenSize);
    },
    methods: {
        checkUrl() {
            // if (window.location.href.indexOf("taichinhtoandien") > -1) {
            //   this.changeTab("taichinhtoandien"); // Gọi hàm changeTab với giá trị hash (vd: 'AIeditor')
            // } else {
            //   window.location.href = this.lang + "/taichinhtoandien#taichinhtoandien/";
            // } ??? tai sao lai fix url the nay ???
        },
        async fetchData() {
            this.apiUrl =
                "https://sheets.googleapis.com/v4/spreadsheets/1EArWilSVZmk23GG5AlCoVov-e1nbVdxbNdNTENzdFwQ/values/jsonUrlLinhVuc?key=AIzaSyB6KdsUEG02YYtkYDjFlVA-HrSvs_PULh4";

            try {
                const response = await axios.get(this.apiUrl);
                const lang = localStorage.getItem("languages") || "vi";

                this.items = response.data.values
                    .map((row) => {
                        if (row[4] && lang && row[4].trim() === lang.trim()) {
                            return {
                                title: row[0],
                                url: row[1],
                                imgLinhVuc: row[2],
                                moTa: row[3],
                            };
                        }
                    })
                    .filter((item) => item !== undefined);

                // console.log("this.items ", this.items);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        },

        changeLanguage(lang) {
            this.currentLanguage = languages[lang];
            localStorage.setItem("languages", lang);
            window.location.reload();
        },
        async layTyGia() {
            await postLayTiGia();
        },

        handleDataReceived() {
            var data = localStorage.getItem("dataCuaHang");
            this.listCuaHang = JSON.parse(data);
        },
        async performPostRequest(id, section) {
            this.lang = localStorage.getItem("languages") || "vi";

            try {
                // Thực hiện POST request
                const response = await axios.post(apiChiTietBaiViet, {
                    id: id,
                    langId: "0",
                });
                if (this.lang === "vi") {
                    this.base64 = response.data.result.content_vi;
                    this.base64Title = response.data.result.title_vi;
                } else if (this.lang === "en") {
                    this.base64 = response.data.result.content_en;
                    this.base64Title = response.data.result.title_en;
                } else if (this.lang === "cn") {
                    this.base64 = response.data.result.content_cn;
                    this.base64Title = response.data.result.title_cn;
                } else if (this.lang === "kr") {
                    this.base64 = response.data.result.content_kr;
                    this.base64Title = response.data.result.title_kr;
                } else {
                    this.base64 = response.data.result.content_vi;
                    this.base64Title = response.data.result.title_vi;
                }

                var title = atob(this.base64Title);
                var decodedString = atob(this.base64);

                // Store content separately for each section

                if (section === "gioiThieu") {
                    this.titleGioiThieu = decodeURIComponent(escape(title));
                    this.contentGioiThieu = decodeURIComponent(escape(decodedString));
                } else if (section === "DiemThanhToan") {
                    this.titleDiemThanhToan = decodeURIComponent(escape(title));
                    this.contentDiemThanhToan = decodeURIComponent(escape(decodedString));
                } else if (section === "DiemDinhDanh") {
                    this.titleDiemDinhDanh = decodeURIComponent(escape(title));
                    this.contentDiemDinhDanh = decodeURIComponent(escape(decodedString));
                } else if (section === "diemthanhtoan") {
                    this.titlePos = decodeURIComponent(escape(title));
                    this.contentPos = decodeURIComponent(escape(decodedString));
                } else if (section === "taichinhtoandien") {
                    this.titleTaichinhtoandien = decodeURIComponent(escape(title));
                    this.contentTaichinhtoandien = decodeURIComponent(escape(decodedString));
                } else if (section === "AIeditor") {
                    this.titleAIeditor = decodeURIComponent(escape(title));
                    this.contentAIeditor = decodeURIComponent(escape(decodedString));
                } else if (section === "LienHe") {
                    this.titleLienHe = decodeURIComponent(escape(title));
                    this.contentLienHe = decodeURIComponent(escape(decodedString));
                } else if (section === "vcard") {
                    this.titleVCard = decodeURIComponent(escape(title));
                    this.contentVCard = decodeURIComponent(escape(decodedString));
                } else if (section === "giaothongthongminh") {
                    this.titleGiaoThong = decodeURIComponent(escape(title));
                    this.contentGiaoThong = decodeURIComponent(escape(decodedString));
                } else if (section === "dichvucongthongminh") {
                    this.titleDichVuCong = decodeURIComponent(escape(title));
                    this.contentDichVuCong = decodeURIComponent(escape(decodedString));
                } else if (section === "ytethongminh") {
                    this.titleYte = decodeURIComponent(escape(title));
                    this.contentYte = decodeURIComponent(escape(decodedString));
                } else if (section === "giaodichthongminh") {
                    this.titleGiaodichthongminh = decodeURIComponent(escape(title));
                    this.contentGiaodichthongminh = decodeURIComponent(escape(decodedString));
                }
                // else if (section === "congTacVien") {
                //   this.titleCongTacVien = decodeURIComponent(escape(title));
                //   this.contentCongTacVien = decodeURIComponent(escape(decodedString));
                // }
                // else if (section === "HuongDan") {
                //   this.titleHuongDan = decodeURIComponent(escape(title));
                //   this.contentHuongDan = decodeURIComponent(escape(decodedString));
                // }
            } catch (error) {
                console.error("Error:", error);
            }
        },

        toggleMenu() {
            this.isMenuVisible = true;
        },
        changeTab(tab) {
            if (window.innerWidth <= 768) {
                this.isMenuVisible = false;
            }
            this.lang = localStorage.getItem("languages") || "vi";

            if (tab === "taichinhtoandien") {
                this.isActivePos = false;
                this.isActiveTaichinhtoandien = true;
                this.isActiveAIeditor = false;
                this.isActiveLienHe = false;
                this.isActiveVcard = false;
                this.isActiveDiemDinhDanh = false;
                this.isActiveDiemThanhToan = false;
                this.isActiveDichVuCong = false;
                this.isActiveGiaoThong = false;
                this.isActiveGiaoDichthongminh = false;
                this.isActiveYte = false;
                this.performPostRequest("1749203550578RBETn", "taichinhtoandien", this.lang);
                // this.performPostRequest("17459097045371VwAU", "taichinhtoandien", this.lang); //taichinhtoandien
            } else if (tab === "diemthanhtoan") {
                this.isActivePos = true;
                this.isActiveTaichinhtoandien = false;
                this.isActiveAIeditor = false;
                this.isActiveLienHe = false;
                this.isActiveVcard = false;
                this.isActiveDichVuCong = false;
                this.isActiveGiaoThong = false;
                this.isActiveGiaoDichthongminh = false;
                this.isActiveYte = false;
                this.performPostRequest("1741085821697JKSk1", "diemthanhtoan", this.lang);
            } else if (tab === "AIeditor") {
                this.isActivePos = false;
                this.isActiveTaichinhtoandien = false;
                this.isActiveAIeditor = true;
                this.isActiveDiemDinhDanh = false;
                this.isActiveDiemThanhToan = false;
                this.isActiveLienHe = false;
                this.isActiveVcard = false;
                this.isActiveGiaoDichthongminh = false;
                this.isActiveDichVuCong = false;
                this.isActiveGiaoThong = false;
                this.isActiveYte = false;
                this.performPostRequest("1750476151949TR06v", "AIeditor", this.lang);
            } else if (tab === "LienHe") {
                this.isActivePos = false;
                this.isActiveTaichinhtoandien = false;
                this.isActiveAIeditor = false;
                this.isActiveDiemDinhDanh = false;
                this.isActiveDiemThanhToan = false;
                this.isActiveLienHe = true;
                this.isActiveVcard = false;
                this.isActiveDichVuCong = false;
                this.isActiveGiaoThong = false;
                this.isActiveGiaoDichthongminh = false;
                this.isActiveYte = false;
                this.performPostRequest("1690272053288yg3c7", "LienHe", this.lang);
            } else if (tab === "gioiThieu") {
                this.isActivePos = false;
                this.isActiveTaichinhtoandien = false;
                this.isActiveAIeditor = false;
                this.isActiveGioiThieu = true;
                this.isActiveDiemThanhToan = false;
                this.isActiveDiemDinhDanh = false;
                this.isActiveDichVuCong = false;
                this.isActiveGiaoThong = false;
                this.isActiveGiaoDichthongminh = false;
                this.isActiveYte = false;
                this.isActiveLienHe = false;
                this.isActiveVcard = false;
                this.performPostRequest("1719997599950aUoQY", "gioiThieu", this.lang);
            } else if (tab === "DiemThanhToan") {
                this.isActiveGioiThieu = false;
                this.isActivePos = false;
                this.isActiveTaichinhtoandien = false;
                this.isActiveAIeditor = false;
                this.isActiveDiemThanhToan = true;
                this.isActiveDiemDinhDanh = false;
                this.isActiveDichVuCong = false;
                this.isActiveGiaoDichthongminh = false;
                this.isActiveGiaoThong = false;
                this.isActiveYte = false;
                this.isActiveLienHe = false;
                this.isActiveVcard = false;
                this.performPostRequest(
                    "17412528497024i7x3",
                    "DiemThanhToan",
                    this.lang
                );
            } else if (tab === "vcard") {
                this.isActiveGioiThieu = false;
                this.isActivePos = false;
                this.isActiveTaichinhtoandien = false;
                this.isActiveAIeditor = false;
                this.isActiveDiemThanhToan = false;
                this.isActiveDiemDinhDanh = false;
                this.isActiveDichVuCong = false;
                this.isActiveGiaoDichthongminh = false;
                this.isActiveGiaoThong = false;
                this.isActiveYte = false;
                this.isActiveLienHe = false;
                this.isActiveVcard = true;
                this.performPostRequest(
                    "169103571793214rn5",
                    "vcard",
                    this.lang
                );
            } else if (tab === "DiemDinhDanh") {
                this.isActiveDiemDinhDanh = true;
                this.isActiveGioiThieu = false;
                this.isActivePos = false;
                this.isActiveTaichinhtoandien = false;
                this.isActiveAIeditor = false;
                this.isActiveDichVuCong = false;
                this.isActiveGiaoThong = false;
                this.isActiveGiaoDichthongminh = false;
                this.isActiveYte = false;
                this.isActiveDiemThanhToan = false;
                this.isActiveLienHe = false;
                this.isActiveVcard = false;
                this.performPostRequest(
                    "1684483847412mqp7d",
                    "DiemDinhDanh",
                    this.lang
                );
            } else if (tab === "giaothongthongminh") {
                this.isActiveGioiThieu = false;
                this.isActivePos = false;
                this.isActiveTaichinhtoandien = false;
                this.isActiveAIeditor = false;
                this.isActiveGiaoDichthongminh = false;
                this.isActiveDiemThanhToan = false;
                this.isActiveDiemDinhDanh = false;
                this.isActiveLienHe = false;
                this.isActiveVcard = false;
                this.isActiveDichVuCong = false;
                this.isActiveGiaoThong = true;
                this.isActiveYte = false;
                this.performPostRequest(
                    "1741163491160s34XH",
                    "giaothongthongminh",
                    this.lang
                );
            } else if (tab === "dichvucongthongminh") {
                this.isActiveGioiThieu = false;
                this.isActivePos = false;
                this.isActiveTaichinhtoandien = false;
                this.isActiveAIeditor = false;
                this.isActiveDiemThanhToan = false;
                this.isActiveDiemDinhDanh = false;
                this.isActiveLienHe = false;
                this.isActiveVcard = false;
                this.isActiveDichVuCong = true;
                this.isActiveGiaoDichthongminh = false;
                this.isActiveGiaoThong = false;
                this.isActiveYte = false;
                this.performPostRequest(
                    "1546059256581d0h0r",
                    "dichvucongthongminh",
                    this.lang
                );
            } else if (tab === "ytethongminh") {
                this.isActiveGioiThieu = false;
                this.isActivePos = false;
                this.isActiveTaichinhtoandien = false;
                this.isActiveAIeditor = false;
                this.isActiveDiemThanhToan = false;
                this.isActiveDiemDinhDanh = false;
                this.isActiveGiaoDichthongminh = false;
                this.isActiveLienHe = false;
                this.isActiveVcard = false;
                this.isActiveDichVuCong = false;
                this.isActiveGiaoThong = false;
                this.isActiveYte = true;
                this.performPostRequest(
                    "1752550189626581gF",
                    "ytethongminh",
                    this.lang
                );
            } else if (tab === "giaodichthongminh") {
                this.isActiveGioiThieu = false;
                this.isActivePos = false;
                this.isActiveTaichinhtoandien = false;
                this.isActiveAIeditor = false;
                this.isActiveDiemThanhToan = false;
                this.isActiveDiemDinhDanh = false;
                this.isActiveGiaoThong = false;
                this.isActiveLienHe = false;
                this.isActiveVcard = false;
                this.isActiveDichVuCong = false;
                this.isActiveYte = false;
                this.isActiveGiaoDichthongminh = true;
                this.performPostRequest(
                    "1752641179197zG30M",
                    "giaodichthongminh",
                    this.lang
                );
            }

            this.activeTab = tab;
            this.showPos = tab === "diemthanhtoan";
            this.showTaichinhtoandien = tab === "taichinhtoandien";
            this.showAIeditor = tab === "AIeditor";
            this.showGioiThieu = tab === "gioiThieu";
            this.showDiemThanhToan = tab === "DiemThanhToan";
            this.showDiemDinhDanh = tab === "DiemDinhDanh";
            this.showLienHe = tab === "LienHe";
            this.showVcard = tab === "vcard";
            this.showGiaoThong = tab === "giaothongthongminh";
            this.showDichVuCong = tab === "dichvucongthongminh";
            this.showYte = tab === "ytethongminh";
            this.showGiaoDichthongminh = tab === "giaodichthongminh";

        },
    },
};
</script>

<style>
.dropbtn {
    background-color: #007abb;
    color: white;
    border: none;
}

.dropdown {
    position: relative;
    display: inline-block;
}

.dropdown-content {
    display: none;
    position: absolute;
    background-color: #f1f1f1;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;
}

.dropdown-content a {
    color: black;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
}

.dropdown:hover .dropdown-content {
    display: block;
}

.dropdown:hover .dropbtn {
    background-color: #007abb !important;
}

.card {
    max-width: 30em;
    flex-direction: row;
    background-color: #696969;
    border: 0;
    box-shadow: 0 7px 7px rgba(0, 0, 0, 0.18);
    margin: 3em auto;
}

.card.dark {
    color: #fff;
}

.card.card.bg-light-subtle .card-title {
    color: dimgrey;
}

.card img {
    max-width: 25%;
    margin: auto;
    padding: 0.5em;
    border-radius: 0.7em;
}

.card-body {
    display: flex;
    justify-content: space-between;
}

.text-section {
    max-width: 90%;
}

.cta-section {
    max-width: 40%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
}

.cta-section .btn {
    padding: 0.3em 0.5em;
    /* color: #696969; */
}

.card.bg-light-subtle .cta-section .btn {
    background-color: #898989;
    border-color: #898989;
}

.ytp-right-controls .ytp-subtitles-button {
    display: none !important;
}

/* iframe {
    pointer-events: none!important;;
} */

@media (min-width: 992px) {
    #taichinhtoandien .vdeoamthanh {
        width: 100% !important;
        display: flex;
        flex-wrap: nowrap;
    }

    #taichinhtoandien .vdeoamthanh .vdtrai {
        width: 32% !important;
    }

    #taichinhtoandien .vdeoamthanh .vdtrai iframe {
        max-width: 560px;
        width: 100%;
        margin: 0 auto;
        height: 320px;
    }

    #taichinhtoandien .vdeoamthanh .vdnoidung {
        width: 68% !important;
        margin-left: 3px;
    }

    #diemthanhtoan .vdeoamthanh {
        width: 100% !important;
        display: flex;
        flex-wrap: nowrap;
    }

    #diemthanhtoan .vdeoamthanh .vdtrai {
        width: 77% !important;
        margin-left: 3px;
    }

    #diemthanhtoan .vdeoamthanh .vdtrai iframe {
        max-width: 1440px;
        width: 100%;
        margin: 0 auto;
        height: 800px;
    }

    #diemthanhtoan .vdeoamthanh .vdnoidung {
        width: 22% !important;
        margin-left: 3px;
        font-size: 18px;
    }
}

@media (max-width: 991.99px) {
    #taichinhtoandien .vdeoamthanh {
        width: 100% !important;
        display: flex;
        flex-wrap: wrap;
    }

    #taichinhtoandien .vdeoamthanh .vdtrai {
        width: 100% !important;
    }

    #taichinhtoandien .vdeoamthanh .vdtrai iframe {
        width: 100%;
        height: 220px;
        max-width: 560px;
        margin: 0 auto;
    }

    #taichinhtoandien .vdeoamthanh .vdnoidung {
        width: 100% !important;
    }

    #diemthanhtoan .vdeoamthanh {
        width: 100% !important;
        display: flex;
        flex-wrap: wrap;
    }

    #diemthanhtoan .vdeoamthanh .vdtrai {
        width: 100% !important;
    }

    #diemthanhtoan .vdeoamthanh .vdtrai iframe {
        width: 100%;
        margin: 0 auto;
        height: 800px;
        height: 220px;
    }

    #diemthanhtoan .vdeoamthanh .vdnoidung {
        width: 100% !important;
        font-size: 18px;
    }
}

@media (max-width: 475px) {
    .card {
        font-size: 0.9em;
    }
}
</style>
